module.exports = __webpack_public_path__ + "4a6107574d07f891ea40b725f2a6cf15.svg";